export function hasActiveRegistration() {
  if (document.body.dataset.authenticated === "true") return false;

  return Array.from(document.querySelectorAll(".signup-modal-body form, form.sign-up-form"))
    .some(form => form.getClientRects().length > 0);
}
